import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

function BackButton() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      className="flex items-center gap-2 px-4 py-2 bg-[#402e2c] text-white rounded-full hover:bg-[#402e2c]/80 transition-colors"
    >
      <ArrowLeftIcon className="h-5 w-5" />
      <span>Back</span>
    </button>
  );
}

export default BackButton; 